import { defaultDashboardPath } from "@dashboard/navigation/dashboardRoutes"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/dashboard")({
  component: Outlet,
  beforeLoad: ({ location }) => {
    const normalizedPathname = location.pathname.replace(/\/+$/, "") || "/"
    if (normalizedPathname === "/dashboard") {
      throw redirect({ href: defaultDashboardPath })
    }
  },
})
